import { useQuery } from 'react-query'
import { gql } from 'graphql-request'

import { gqlQuery } from '@hapana/shared/web/services/requests.service'
import type { ClientAlertSerialized } from '@hapana/shared/schemas/client-alerts'

export interface ClientCustomAlertsResponse {
  clientAlerts: {
    alerts: ClientAlertSerialized[]
  }
}

export const clientCustomAlertsQuery = gql`
  query ClientAlerts($clientId: String!, $siteId: String!) {
    clientAlerts(clientId: $clientId, siteId: $siteId) {
      alerts {
        alertId
        clientId
        siteId
        title
        description
        startDate
        endDate
        createdByName
        createdAt
        updatedAt
      }
    }
  }
`

export const getClientCustomAlerts = gqlQuery<ClientCustomAlertsResponse>({
  key: 'client-alerts',
  query: clientCustomAlertsQuery,
})

interface UseClientCustomAlertsOptions {
  clientId: string | undefined
  siteId: string | null | undefined
}

export const useClientCustomAlerts = ({ clientId, siteId }: UseClientCustomAlertsOptions) => {
  return useQuery<ClientCustomAlertsResponse, Error>(
    [getClientCustomAlerts.key, { clientId, siteId }],
    () =>
      getClientCustomAlerts.query({
        pageParam: { clientId, siteId },
      }) as unknown as Promise<ClientCustomAlertsResponse>,
    {
      enabled: !!clientId && !!siteId,
    }
  )
}
